import "./index.scss";
import HighlightIcons from "assets/images/sell-banners/sell-highlight-icons.png";

export const HighlightStep = ({ title, text }) => (
  <div className="highlight-step">
    <img src={HighlightIcons} alt="highlight icon" />
    <h3>{title}</h3>
    <p className="highlight-text">{text}</p>
  </div>
);
